import { render, staticRenderFns } from "./SupportTicket.vue?vue&type=template&id=61a6ddce&"
import script from "./SupportTicket.vue?vue&type=script&lang=ts&"
export * from "./SupportTicket.vue?vue&type=script&lang=ts&"
import style0 from "./SupportTicket.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports